import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';
import { Company } from 'src/app/domains/companies/models';
import { ConnectivityItem, CONNECTIVITY_TYPE, UIConnectivityItem } from 'src/app/domains/connectivity/models/connectivity.model';
import { ConnectivityService } from 'src/app/domains/connectivity/services/connectivity.service';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { AddConnectionPopupComponent } from '../add-connection-popup/add-connection-popup.component';

@Component({
  selector: 'gdp-company-connectivity-main',
  templateUrl: './company-connectivity-main.component.html',
  styleUrls: ['./company-connectivity-main.component.scss']
})
export class CompanyConnectivityMainComponent implements OnInit, OnDestroy {
  @Input() company: Company;
  public connections: UIConnectivityItem[] = [];
  public loading = {
    connections: false,
    lockUnlock: false
  };
  public CONNECTIVITY_TYPE = CONNECTIVITY_TYPE;
  public isLocked: boolean = false;
  public toggle: any = { isAquamarine: true, disabled: false };
  private routerSubscription: Subscription;

  constructor(
    private connectivityService: ConnectivityService,
    private router: Router,
    private modalService: NgbModal,
    private notification: NotificationService
  ) {}

  ngOnInit(): void {
    this.getConnections();
  }

  private getConnections(): void {
    this.loading.connections = true;
    this.connectivityService.getConnectionsByCompanyId(this.company.companyId)
      .subscribe((res: ConnectivityItem[]) => {
        this.connections = res;
        this.isLocked = this.connections.some(el => el.is_locked);
        this.toggle.disabled = this.connections.length === 0;
        this.loading.connections = false;
      }, () => {
        this.loading.connections = false;
      });
  }

  openConnection(c: UIConnectivityItem) {
    c.loading = true;
    this.routerSubscription = this.router.events
      .pipe(
        filter((e: RouterEvent) => {
          return e instanceof NavigationEnd
            || e instanceof NavigationCancel
            || e instanceof NavigationError})
      )
      .subscribe(
        () => {
          c.loading = false;
          this.routerSubscription.unsubscribe();
        }
      );
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }

  get shouldShow() {
    return !this.router.url.includes('overview') && !this.router.url.includes('equipment');
  }

  public openAddConnectionPopup(): void {
    const modal = this.modalService.open(AddConnectionPopupComponent, {
      size: 'lg'
    });
    modal.componentInstance.companyId = this.company.companyId;
    modal.componentInstance.onAddConnection.pipe(take(1)).subscribe(() => {
      this.getConnections();
      this.notification.success('company.user.user-added');
    });
  }

  lockUnlockConnections(e) {
    this.loading.lockUnlock = true;
    if(e.target.checked) {
      this.connectivityService.lockConnectivity(this.company.companyId).subscribe(() => {
        this.isLocked = e.target.checked;
        this.getConnections();
        this.loading.lockUnlock = false;
      }, () => {
        this.isLocked = false;
        this.loading.lockUnlock = false;
      })
    } else {
      this.connectivityService.unlockConnectivity(this.company.companyId).subscribe(() => {
        this.isLocked = e.target.checked;
        this.getConnections();
        this.loading.lockUnlock = false;
      }, () => {
        this.isLocked = true;
        this.loading.lockUnlock = false;
      })
    }
  }
}
